import React from 'react';
import './fadeInScript';

const FadeInContainer = ({ direction = 'up', children }) => (
  <div className={`fade-in-container fade-${direction}`}>{children}</div>
);

export default FadeInContainer;
